



































































































































































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";
import filesaver from "file-saver";
import moment from "moment";

import { getColor, fromSourceList } from "@/libs/colors";

@Component
export default class extends Mixins(MyList) {
  dispatchType = "users/getUsers";

  selectedRowKeys: any[] = [];

  fromSourceList: any[] = fromSourceList;

  // 操作搜索栏的展开和折叠
  isFlag = false;

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "头像",
      scopedSlots: { customRender: "avatar" }
    },
    {
      title: "会员名称（昵称）",
      scopedSlots: { customRender: "username" }
    },
    {
      title: "手机号（归属地）",
      scopedSlots: { customRender: "mobile" }
    },
    {
      title: "来源",
      scopedSlots: { customRender: "from_source" }
    },
    {
      title: "羽约余额",
      scopedSlots: { customRender: "balance" }
    },
    {
      title: "积分",
      dataIndex: "score"
    },
    {
      title: "注册时间/注册场馆",
      scopedSlots: { customRender: "created_time" }
    },
    {
      title: "C端首次登录",
      scopedSlots: { customRender: "first_login_c" }
    },
    {
      title: "B端首次登录",
      scopedSlots: { customRender: "first_login_b" }
    },
    // {
    //   title: '性别',
    //   scopedSlots: { customRender: 'sex' }
    // },
    // {
    //   title: '实名认证',
    //   scopedSlots: { customRender: 'identity_status' }
    // },
    {
      title: "订场次数/最近订场",
      scopedSlots: { customRender: "order_count" }
    },

    // {
    //   title: '注册来源场馆',
    //   dataIndex: 'from_stadium'
    // },
    {
      title: "打球次数/最后活动场馆/最近打球",
      scopedSlots: { customRender: "stadium_name" }
    },
    {
      title: "球友添加",
      key: "player_count",
      scopedSlots: { customRender: "player_count" },
      sorter: true
    },
    {
      title: "Taisam添加",
      key: "player_count1",
      scopedSlots: { customRender: "player_count1" },
      sorter: true
    },
    {
      title: "操作",
      scopedSlots: { customRender: "action" }
    }
  ];

  getColor(fromSource: number): string {
    return getColor(fromSource);
  }

  mounted() {
    this.searchData.latest_play_time1=moment().add(-1,'months').format('YYYY-MM-DD HH:mm:ss')
    this.loadData();
  }

  async exportExcel() {
    this.$confirm({
      title: "确认信息",
      content: "确定要导出数据吗",
      onOk: async () => {
        const res = await this.$store.dispatch("users/getUsers", {
          ...this.reloadQueryData
        });
        if (res && res.data) {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          filesaver.saveAs(blob, `用户列表${moment().format("YYYY-MM-DD HH:mm:ss")}.xlsx`);
        }
      }
    });
  }

  handleTableSearch1(e: any) {
    e.preventDefault();
    this.selectedRowKeys = [];
    this.handleTableSearch(e);
  }

  // 选择用户
  onSelectChange(selectedRowKeys: any, selectedRows: any) {
    // console.log(selectedRows);
    // console.log(selectedRowKeys);

    this.selectedRowKeys = selectedRowKeys;
  }

  // 发起智能组局
  handleStart() {
    if (this.selectedRowKeys.length < 2) {
      this.$message.error("请至少选择2个用户来发起组局");
      return;
    }
    this.$confirm({
      title: "确认信息",
      content: "你确定要发起智能组局吗？",
      centered: true,
      onOk: async () => {
        const res = await this.$store.dispatch("users/makeAGroup", {
          user_ids: this.selectedRowKeys.join(",")
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  addBlock(record:any,flag:any){
    this.$confirm({
      title: "确认信息",
      content: "你确定要将用户《" + record.username + "》加入黑名单吗？",
      centered: true,
      onOk: async () => {
        const res = await this.$store.dispatch("blocklist/add", {
          mobile:record.mobile,
          type:flag,
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

}
